import { createContext, useContext, useState, useEffect, useRef } from "react";
import { backend_url } from "./constants";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const accessTokenRef = useRef(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  function setAccessToken(token) {
    accessTokenRef.current = token;
  }

  function getAccessToken() {
    return accessTokenRef.current;
  }

  useEffect(() => {
    async function bootstrapAuth() {
      try {
        const res = await fetch(backend_url + "/api/token/refresh/", {
          method: "POST",
          credentials: "include",
        });

        if (!res.ok) throw new Error("No session");

        const data = await res.json();
        setAccessToken(data.access);
        setIsAuthenticated(true);
      } catch {
        setAccessToken(null);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    }

    bootstrapAuth();
  }, []);
  function loginWithAccessToken(token) {
    setAccessToken(token);
    setIsAuthenticated(true);
  }

  function logoutOfAccessToken() {
    setAccessToken(null);
    setIsAuthenticated(false);
  }
  return (
    <AuthContext.Provider
      value={{
        getAccessToken,
        loginWithAccessToken,
        isAuthenticated,
        isLoading,
        logoutOfAccessToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function useApi() {
  const { getAccessToken, loginWithAccessToken } = useAuth();
  async function refreshAccessToken() {
    const res = await fetch(backend_url + "/api/token/refresh/", {
      method: "POST",
      credentials: "include",
    });

    if (!res.ok) throw new Error("Session expired");

    const data = await res.json();
    loginWithAccessToken(data.access);
    return data.access;
  }

  async function apiFetch(url, options = {}) {
    const accessToken = getAccessToken();
    let res = await fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (res.status === 401) {
      const newToken = await refreshAccessToken();
      let new_res = await fetch(url, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${newToken}`,
        },
      });
      return new_res;
    }

    return res;
  }

  return { apiFetch };
}


export function createAPIPOSTPayload(payload) {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }
}